import Layout from '../components/Layout'
import ContactButtons from '../components/ContactButtons'

function About() {
  return (
    <Layout title='About'>
      <div className='flex flex-col-reverse lg:flex-row lg:gap-12'>
        <div className='lg:w-3/5 pt-8 lg:pt-0'>
          <h1 className='text-lg font-bold lg:text-2xl'>Hi, I'm Jonghwi.</h1>
          <div className='text-sm text-gray-600 space-y-5 mt-4 leading-relaxed'>
            <p>
              When I was in college in Korea, I worked part time as an English
              teaching assistant at an after-school center. One day a student
              told me they were learning C at school. I wondered what coding was
              and why it had become part of the regular curriculum, so I bought
              a C textbook to find out. My first program printed the
              multiplication table, and I liked it enough to keep going.
            </p>
            <p>
              I've taught myself ever since, mostly by building things and
              working out why they break. That habit started in QA, where my job
              was to find the ways an app fails, and it's why most of my blog
              posts are write-ups of problems I tracked down.
            </p>
            <p>
              Freelancing for small businesses under{' '}
              <a
                href='https://www.webtamin.com/'
                target='_blank'
                rel='noreferrer noopener'
                className='text-blue-500'
              >
                Webtamin
              </a>{' '}
              showed me what the work is for. Most of my clients had one
              question about their website: does it bring in customers? For an
              auto repair shop, answering it meant a fast site, local SEO, and
              tracking that showed which channel each lead came from. That
              project is where I started to see development as a way to solve
              someone else's problem.
            </p>
            <p>
              PureLog came from a problem of my own. The workout apps I used
              had social feeds that distracted me and features like routines
              that I never used but that made the apps feel heavy. So I built a
              log with only the two things I actually use, logging and
              progress, and replaced routines with suggestions based on what
              I've logged before. It was my first project built with Claude
              Code. Claude wrote most of the code. I decided what each feature
              should do, tested it locally, and moved on only once it worked. I
              also use the app whenever I work out and note anything that feels
              off, like a screen that loads with no spinner, then go back and
              fix it. My client sites, by contrast, I coded by hand, mostly
              without AI tools.
            </p>
            <p>
              I still work as a medical interpreter, which keeps me practiced at
              explaining complex information to people outside the field. Next,
              I'm looking for a development team where I can work on larger
              systems and learn from experienced engineers.
            </p>
          </div>
          <ContactButtons className='mt-8' />
        </div>

        <div className='lg:w-2/5'>
          <img
            className='grayscale w-full max-w-sm mx-auto lg:mx-0'
            src={`${process.env.PUBLIC_URL}/images/jonghwikim.webp`}
            alt='Jonghwi Kim'
          />
        </div>
      </div>
    </Layout>
  )
}

export default About
